"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[89360],{

/***/ 81512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Countdown; }
});

// EXTERNAL MODULE: ../../packages/types/dist/shared/index.es.js + 1 modules
var index_es = __webpack_require__(184019);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Countdown/DefaultCountdown.es.js





const sizeMaps = {
  [index_es/* DSSize.small */.hT.small]: "24px",
  [index_es/* DSSize.medium */.hT.medium]: "32px",
  [index_es/* DSSize.default */.hT["default"]]: "45px",
  [index_es/* DSSize.large */.hT.large]: "55px"
};
const fontSizeMaps = {
  [index_es/* DSSize.small */.hT.small]: "12px",
  [index_es/* DSSize.medium */.hT.medium]: "16px",
  [index_es/* DSSize.default */.hT["default"]]: "20px",
  [index_es/* DSSize.large */.hT.large]: "24px"
};
const DefaultCountdown = ({
  duration,
  size
}) => {
  return /* @__PURE__ */ react.createElement(react.Fragment, null, duration.days > 0 && /* @__PURE__ */ react.createElement(CountdownText, null, (0,i18n_es.t)("K\u1EBFt th\xFAc sau"), " ", /* @__PURE__ */ react.createElement(Bold, null, duration.days), " ", (0,i18n_es.t)("ng\xE0y")), duration.milliseconds > 0 && /* @__PURE__ */ react.createElement(Timer, null, /* @__PURE__ */ react.createElement(Pad, {
    size
  }, duration.hours.toString().padStart(2, "0")), /* @__PURE__ */ react.createElement(Pad, {
    size
  }, duration.minutes.toString().padStart(2, "0")), /* @__PURE__ */ react.createElement(Pad, {
    size
  }, duration.seconds.toString().padStart(2, "0"))));
};
const CountdownText = emotion_styled_browser_esm["default"].p`
  color: #fff;
  text-align: center;
  font-size: 1rem;
`;
const Bold = emotion_styled_browser_esm["default"].span`
  font-weight: 600;
  font-size: 1.3rem;
`;
const Timer = emotion_styled_browser_esm["default"].div`
  display: flex;
  justify-content: center;
`;
const Pad = emotion_styled_browser_esm["default"].div(({ size }) => `
  width: ${sizeMaps[size]};
  height: ${sizeMaps[size]};
  font-size: ${fontSizeMaps[size]};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 8px;
  color: white;
  border-radius: 5px;
  background-image: linear-gradient(rgb(74, 74, 74), rgb(35, 34, 34));
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/hooks/useTimer.es.js
var useTimer_es = __webpack_require__(808586);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Countdown/Countdown.es.js





const DefaultRenderer = (duration, size = index_es/* DSSize.default */.hT["default"]) => /* @__PURE__ */ react.createElement(DefaultCountdown, {
  duration,
  size
});
const Countdown = ({
  date,
  renderer = DefaultRenderer,
  size = index_es/* DSSize.default */.hT["default"],
  className
}) => {
  const timer = (0,useTimer_es/* useTimer */.J)(date);
  return /* @__PURE__ */ react.createElement("div", {
    className
  }, renderer && renderer(timer, size));
};




/***/ }),

/***/ 834942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ CustomCategoryList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CategoryItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  text-align: center;
  padding: 4px;
`;
const Container = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  width: '100%';
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const changeDisplayOrderCategoryList = (categoryList) => {
  const size = categoryList.length;
  const evenNumbers = [];
  const oddNumbers = [];
  for (let i2 = 0; i2 < size; i2++) {
    if (i2 % 2 === 0) {
      evenNumbers.push(i2);
    } else {
      oddNumbers.push(i2);
    }
  }
  const result = new Array(size);
  let i = 0;
  evenNumbers.forEach((index) => {
    result[index] = categoryList[i++];
  });
  oddNumbers.forEach((index) => {
    result[index] = categoryList[i++];
  });
  return result;
};
const CustomCategoryList = (_a) => {
  var _b = _a, {
    categoryList,
    colNum = 4,
    iconSize = 48,
    regionName,
    targetName,
    rowNum = 2
  } = _b, props = __objRest(_b, [
    "categoryList",
    "colNum",
    "iconSize",
    "regionName",
    "targetName",
    "rowNum"
  ]);
  if (!(categoryList == null ? void 0 : categoryList.length))
    return null;
  const flow = (categoryList == null ? void 0 : categoryList.length) < colNum * rowNum ? "row" : "column";
  const displayCategory = flow === "column" ? changeDisplayOrderCategoryList(categoryList) : categoryList;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, __spreadValues({
    style: {
      display: "grid",
      gridTemplateRows: `repeat(${rowNum}, auto)`,
      gridTemplateColumns: `repeat(${colNum}, auto)`,
      gridAutoFlow: flow
    }
  }, props), displayCategory.map((category, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    key: index,
    style: {
      width: `calc((100vw - 2rem)/${colNum})`,
      flexShrink: 0
    }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, __spreadProps(__spreadValues({
    key: index
  }, category.link), {
    as: category.as
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CategoryItem, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName,
    contentName: category.id,
    target: targetName,
    index
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .LazyImage */ .w, {
    contain: true,
    width: iconSize,
    height: iconSize,
    imageWidth: 80,
    src: category.imgUrl,
    borderRadius: 4,
    alt: category.name
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Caption */ .YS, {
    level: 1,
    line: 2,
    marginTop: "s4"
  }, category.name)))))));
};




/***/ }),

/***/ 783047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ index_es_HotDealTab; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/hooks/useTimer.es.js
var useTimer_es = __webpack_require__(808586);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/HotDeal/mobile/HotDealTab.es.js








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RightOutlined = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(64871), __webpack_require__.e(73936)]).then(__webpack_require__.bind(__webpack_require__, 564871)).then((mod) => mod.RightOutlined));
const HotDealTab = (_a) => {
  var _b = _a, {
    tabs,
    label,
    activeTabId,
    productsCarousel,
    handleChangeTab,
    className
  } = _b, props = __objRest(_b, [
    "tabs",
    "label",
    "activeTabId",
    "productsCarousel",
    "handleChangeTab",
    "className"
  ]);
  const activeTab = tabs.find((tab) => tab.id === activeTabId);
  const timer = (0,useTimer_es/* useTimer */.J)((activeTab == null ? void 0 : activeTab.endAt) || new Date());
  if (!activeTab)
    return null;
  return /* @__PURE__ */ react.createElement(react.Fragment, null, !!label && /* @__PURE__ */ react.createElement(BlockHeader_es/* BlockHeader */.t, {
    titleColor: "primary",
    title: label,
    style: { paddingLeft: "24px" }
  }), /* @__PURE__ */ react.createElement(TabWrapper, __spreadValues({}, props), !!activeTab.backgroundImage ? /* @__PURE__ */ react.createElement(CustomImage, {
    lazy: false,
    fetchpriority: "high",
    src: activeTab.backgroundImage,
    alt: activeTab.title,
    objectFit: "contain"
  }) : null, /* @__PURE__ */ react.createElement(TabHeader, null, tabs.slice(0, 4).map((tab, index) => /* @__PURE__ */ react.createElement(TabItem, {
    key: index,
    "data-index": index,
    onClick: () => handleChangeTab(tab.id),
    className: tab.id === activeTab.id ? "active" : ""
  }, /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 1,
    weight: "medium",
    line: 2,
    className: "title"
  }, tab.title), tab.description && /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 3,
    weight: "regular",
    line: 2
  }, tab.description), !!tab.isDisplayCountdown && /* @__PURE__ */ react.createElement(Timer, null, timer.hours.toString().padStart(2, "0"), "\xA0:\xA0", timer.minutes.toString().padStart(2, "0"), "\xA0:\xA0", timer.seconds.toString().padStart(2, "0")), /* @__PURE__ */ react.createElement(Decor, null)))), /* @__PURE__ */ react.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react.createElement("div", {
    style: { textAlign: "right", padding: "32px 16px" }
  }, activeTab.link && /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, {
    href: activeTab.link
  }, /* @__PURE__ */ react.createElement("span", {
    style: { color: "white" }
  }, (0,i18n_es.t)("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ react.createElement(RightOutlined, {
    color: "white"
  }))), Object.keys(productsCarousel).length ? /* @__PURE__ */ react.createElement(ProductCarousel_es/* ProductCarousel */.G, __spreadValues({}, productsCarousel)) : /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    height: 300
  }))));
};
const TabWrapper = emotion_styled_browser_esm["default"].div`
  background-color: #f3f3f7;
  min-height: 412px;
  ${BaseProps_index_es/* CommonStyles */.F}
  position: relative;
  overflow: hidden;
`;
const Wrapper = emotion_styled_browser_esm["default"].div`
  background-size: cover;
  background-position: center center;
  margin-bottom: 8px;
  padding: 16px 8px;
  position: relative;
`;
const TabHeader = emotion_styled_browser_esm["default"].div`
  height: 60px;
  display: flex;
  margin-left: 16px;
`;
const TabItem = emotion_styled_browser_esm["default"].div(({ theme }) => `
  width: 84px;
  height: 84px;
  text-align: center;
  margin-right: 8px;
  padding: 16px 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background: white;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  border: 1px solid ${theme == null ? void 0 : theme.colors.border};
  border-radius: 8px;
  position: relative;
  &.active {
    background: ${theme == null ? void 0 : theme.colors.primary700};
    color: white;
    padding: 0;
    transition: all 0.2s ease-in-out 0s;
    border-style: none;
    .title{
      color: white;
    }
  }
`);
const Decor = emotion_styled_browser_esm["default"].div(({ theme }) => `
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  position: absolute;
  bottom: -5px;
  .active & {
    background: ${theme == null ? void 0 : theme.colors.primary700};
  }
`);
const Timer = emotion_styled_browser_esm["default"].div(({ theme }) => `
  padding: 0 8px;
  font-size: 10px;
  background: white;
  border-radius: 5px;
  display: none;
  z-index: 5;
  .active & {
    color: ${theme == null ? void 0 : theme.colors.link700};
    display: block;
    font-weight: 400;
  }
`);
const CustomImage = (0,emotion_styled_browser_esm["default"])(Image_es/* Image */.E)`
  position: absolute;
  display: block;
  overflow: hidden;
  img {
    padding-top: 60px;
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RightOutlined.es.js
var RightOutlined_es = __webpack_require__(203494);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NextImage.es.js
var NextImage_es = __webpack_require__(401204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Countdown/Countdown.es.js + 1 modules
var Countdown_es = __webpack_require__(81512);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/HotDeal/desktop/HotDealTab.es.js









var HotDealTab_es_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var HotDealTab_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var HotDealTab_es_hasOwnProp = Object.prototype.hasOwnProperty;
var HotDealTab_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var HotDealTab_es_defNormalProp = (obj, key, value) => key in obj ? HotDealTab_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var HotDealTab_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (HotDealTab_es_hasOwnProp.call(b, prop))
      HotDealTab_es_defNormalProp(a, prop, b[prop]);
  if (HotDealTab_es_getOwnPropSymbols)
    for (var prop of HotDealTab_es_getOwnPropSymbols(b)) {
      if (HotDealTab_es_propIsEnum.call(b, prop))
        HotDealTab_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var HotDealTab_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (HotDealTab_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && HotDealTab_es_getOwnPropSymbols)
    for (var prop of HotDealTab_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && HotDealTab_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HotDealTab_es_HotDealTab = (_a) => {
  var _b = _a, {
    tabs,
    activeTabId,
    productsCarousel,
    handleChangeTab,
    className
  } = _b, props = HotDealTab_es_objRest(_b, [
    "tabs",
    "activeTabId",
    "productsCarousel",
    "handleChangeTab",
    "className"
  ]);
  const activeTab = tabs.find((tab) => tab.id === activeTabId);
  if (!activeTab)
    return null;
  return /* @__PURE__ */ react.createElement(HotDealTab_es_TabWrapper, HotDealTab_es_spreadValues({}, props), !!activeTab.backgroundImage && /* @__PURE__ */ react.createElement(NextImage_es/* NextImage */.o, {
    style: {
      borderRadius: "5px 5px 0 0"
    },
    layout: "fill",
    src: activeTab.backgroundImage,
    alt: activeTab.title,
    priority: true,
    objectFit: "cover",
    objectPosition: "top left"
  }), /* @__PURE__ */ react.createElement(HotDealTab_es_TabHeader, null, tabs.map((tab, index) => /* @__PURE__ */ react.createElement(HotDealTab_es_TabItem, HotDealTab_es_spreadValues({
    key: tab.id,
    "data-index": index,
    onClick: () => handleChangeTab(tab.id),
    className: tab.id === activeTab.id ? "active" : ""
  }, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "hotDealTab",
    contentName: tab.title
  })), /* @__PURE__ */ react.createElement(index_es/* Title */.Dx, {
    line: 1,
    style: { textAlign: "center" }
  }, tab.title), tab.description && /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    line: 1,
    style: { textAlign: "center" }
  }, tab.description)))), /* @__PURE__ */ react.createElement("div", {
    style: { position: "relative", textAlign: "right", padding: "20px" }
  }, (activeTab == null ? void 0 : activeTab.link) && /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, {
    href: activeTab.link
  }, /* @__PURE__ */ react.createElement("span", {
    style: { color: "white" }
  }, (0,i18n_es.t)("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ react.createElement(RightOutlined_es/* RightOutlined */.g, {
    color: "white"
  }))), /* @__PURE__ */ react.createElement(Row_es/* Row */.X, null, /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 2,
    style: { margin: "auto" }
  }, !!activeTab.isDisplayCountdown && /* @__PURE__ */ react.createElement(CountdownTime, {
    date: activeTab.endAt
  })), /* @__PURE__ */ react.createElement(Col_es/* Col */.JX, {
    span: 10
  }, /* @__PURE__ */ react.createElement(Carousel, null, Object.keys(productsCarousel).length ? /* @__PURE__ */ react.createElement(ProductCarousel_es/* ProductCarousel */.G, __spreadProps(HotDealTab_es_spreadValues({}, productsCarousel), {
    regionName: "hotDeal",
    key: activeTab.id
  })) : /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    height: 300
  })))));
};
const HotDealTab_es_TabWrapper = emotion_styled_browser_esm["default"].div`
  background-color: #f3f3f7;
  ${BaseProps_index_es/* CommonStyles */.F}
  position: relative;
  overflow: hidden;
  padding-bottom: 12px;
`;
const HotDealTab_es_TabHeader = emotion_styled_browser_esm["default"].div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px 8px 0px 0px;
`;
const HotDealTab_es_TabItem = emotion_styled_browser_esm["default"].div(({ theme }) => `
  height: 60px;
  padding: 0.5rem 1rem 0 1rem;
  border-radius: 5px 5px 0 0;
  flex: 1;
  cursor: pointer;
  background: white;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  position: relative;
  &.active {
    background: transparent;
    color: white;
  }
  &:not(:first-child):before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid white;
    position: absolute;
    left: -5px;
    top: 0;
  }
`);
const CountdownTime = (0,emotion_styled_browser_esm["default"])(Countdown_es/* Countdown */.I)`
  position: relative;
  left: 1rem;
  bottom: 0;
`;
const Carousel = emotion_styled_browser_esm["default"].div`
  margin-left: 48px;
  margin-right: 16px;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/HotDeal/index.es.js





var index_es_defProp = Object.defineProperty;
var index_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var index_es_hasOwnProp = Object.prototype.hasOwnProperty;
var index_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var index_es_defNormalProp = (obj, key, value) => key in obj ? index_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var index_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (index_es_hasOwnProp.call(b, prop))
      index_es_defNormalProp(a, prop, b[prop]);
  if (index_es_getOwnPropSymbols)
    for (var prop of index_es_getOwnPropSymbols(b)) {
      if (index_es_propIsEnum.call(b, prop))
        index_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const index_es_HotDealTab = (props) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  if (isMobile)
    return /* @__PURE__ */ react.createElement(HotDealTab, index_es_spreadValues({}, props));
  return /* @__PURE__ */ react.createElement(HotDealTab_es_HotDealTab, index_es_spreadValues({}, props));
};




/***/ }),

/***/ 401204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ NextImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(481633);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const NextImage = (_a) => {
  var _b = _a, { loader } = _b, rest = __objRest(_b, ["loader"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_image__WEBPACK_IMPORTED_MODULE_1___default()), __spreadProps(__spreadValues({}, rest), {
    loader: loader || defaultLoader
  }));
};
function defaultLoader({ src, width }) {
  if (src && src.includes("googleusercontent.com")) {
    return `${src}=rw-w${width}`;
  }
  return src;
}




/***/ }),

/***/ 652833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ RecentSearch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(877936);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(982226);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);





const RecentSearch = ({
  data,
  onClickSearchItem
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !!data.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W, {
    paddingTop: "s8",
    paddingBottom: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
    marginBottom: "s8"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("T\xECm ki\u1EBFm g\u1EA7n \u0111\xE2y")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentWrapper, null, data.map((history, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    key: index,
    marginRight: "s8",
    borderRadius: "m",
    borderWeight: "l",
    borderColor: "divider",
    borderStyle: "solid",
    padding: "s8",
    maxWidth: "40vw",
    align: "center",
    onClick: () => onClickSearchItem(history.query)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .SearchOutlined */ .l, {
    size: 24,
    style: { minWidth: 24 },
    color: "textSecondary"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    width: "70%",
    line: 2,
    marginLeft: "s8"
  }, history.query))))));
};
const ContentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  display: -webkit-inline-box;
  width: 100%;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;




/***/ }),

/***/ 808586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useTimer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(487319);



const useTimer = (endAt) => {
  const [time, setTime] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .calculateTimeDelta */ .m)(new Date(), endAt));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setTime((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .calculateTimeDelta */ .m)(new Date(), endAt));
    const timer = setInterval(() => setTime((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_1__/* .calculateTimeDelta */ .m)(new Date(), endAt)), 1e3);
    return () => {
      clearInterval(timer);
    };
  }, [endAt]);
  return time;
};




/***/ })

}]);